import { BriefSection, DynamicSection, isSectionEmpty, SectionTypes, ViewSection } from '@fiverr-private/ai_brief';
import { BriefInitialValues } from '../../../context/BriefCreationContext';
import { BriefClassificationResponse } from '../../../api';
import { appTranslate } from '../../../i18n';
import { NeedTypeSelector } from './NeedTypeSelector';
import { NeedTypeSectionTags } from './NeedTypeSectionTags';
import { BriefNeedType } from './types';

export { type BriefNeedType } from './types';
export { NeedTypeOption } from './NeedTypeOption';
export { NeedTypeSelector };
export { AdditionalWorkCheckbox } from './AdditionalWorkCheckbox';

export const NEED_TYPE_SECTION_ID = 'need_type';

export const getNeedTypeSection = (
    briefClassification: BriefClassificationResponse,
    initialValues?: Partial<BriefInitialValues>
): DynamicSection => {
    const needType = briefClassification.resolved_data?.need_type ?? ({} as BriefNeedType);
    const initialNeedType = initialValues?.needType ? { initialNeedType: initialValues?.needType } : {};
    const briefNeedType = { ...needType, ...initialNeedType };

    return {
        id: NEED_TYPE_SECTION_ID,
        mandatory: true,
        title: appTranslate('sections.need_type.title').toString(),
        content: briefNeedType,
        included: true,
        disableInitialScroll: true,
        type: SectionTypes.dynamic,
        EditComponent: NeedTypeSelector,
        hideActions: true,
        focused: !!initialValues?.needType || !briefNeedType.needType,
        extraHighlighted: true,
        customMargin: (section: BriefSection, editedSectionId: string | null) =>
            section.id === editedSectionId && isSectionEmpty(section) ? { marginTop: '3' } : {},
    };
};

export const getNeedTypeTagsSection = (enableEnhancedUx = false): ViewSection => ({
    id: 'need_type_tags',
    editSectionId: NEED_TYPE_SECTION_ID,
    content: '',
    included: true,
    disableViewInteraction: enableEnhancedUx,
    type: SectionTypes.view,
    ViewComponent: NeedTypeSectionTags,
    showWhen: (brief) => {
        const needType = brief.sections.find((section) => section.id === NEED_TYPE_SECTION_ID)
            ?.content as unknown as BriefNeedType;

        return !!needType?.needType;
    },
    moveActionsToSide: () => true,
    customMargin: (section: BriefSection, editedSectionId: string | null) =>
        !editedSectionId ||
        (editedSectionId && ![section.id, (section as ViewSection).editSectionId].includes(editedSectionId))
            ? { marginBottom: '3' }
            : {},
});
